export const PAYMENTS_BORROWER_ROLE = "payments.borrower";
export const PAYMENTS_SUPPORT_ROLE = "payments.support";
export const CLIENT_ADMIN_ROLE = "client.admin";

export const BORROWER = "Borrower";
export const CLIENT = "Client";
export const CLIENT_ADMIN = "Client Admin";

export const USER_IMPERSONATION_NOT_BORROWER = "User found is not a borrower";
export const USER_IMPERSONATION_NOT_ALLOWED =
  "You are not allowed to impersonate users. Contact your administrator.";

/** Cognito group / claim strings → canonical role ids */
export const COGNITO_ROLE_ALIASES = {
  ClientAdmin: CLIENT_ADMIN_ROLE,
  "Client Admin": CLIENT_ADMIN_ROLE,
  clientadmin: CLIENT_ADMIN_ROLE,
  PaymentsBorrower: PAYMENTS_BORROWER_ROLE,
  "Payments Borrower": PAYMENTS_BORROWER_ROLE,
  paymentsborrower: PAYMENTS_BORROWER_ROLE,
  PaymentsSupport: PAYMENTS_SUPPORT_ROLE,
  "Payments Support": PAYMENTS_SUPPORT_ROLE,
  paymentssupport: PAYMENTS_SUPPORT_ROLE,
};

export const canonicalizeCognitoRole = (role) => {
  if (!role) {
    return role;
  }
  const key = String(role).trim();
  return COGNITO_ROLE_ALIASES[key] ?? COGNITO_ROLE_ALIASES[key.toLowerCase()] ?? key;
};
